/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconAlertSmallOff = createReactComponent("outline", "alert-small-off", "IconAlertSmallOff", [["path", { "d": "M12 16h.01", "key": "svg-0" }], ["path", { "d": "M12 7v1", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

export { IconAlertSmallOff as default };
//# sourceMappingURL=IconAlertSmallOff.mjs.map
